<template>
  <div class="step-bar" v-if="prescriptionData.isPrescription">
    <div class="step-left">
      <div class="step-reference">
        <!-- <img src="@/assets/images/reference.png" alt="">
        <span>{{$lang('参考')}}</span> -->
      </div>
      <el-steps :active="getActive()+1" class="step-line" align-center>
        <el-step
          v-for="(item, index) in stepList"
          :key="item.title"
          :class="{'last-img': index === 5}"
        >
          <template slot="icon">
            <div class="icon-content">
              <img class="step-img"
                :src="require(`@/assets/images/${getImg(item,index)}.png`)"
                alt="">
              <span>{{$lang(item.title)}}</span>
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <div class="step-time">
      <div class="step-time-top">
        <img :src="require(`@/assets/images/${stepStyle[prescriptionData.isPrescription].color}.png`)" alt="">
        <span>{{$lang(stepStyle[prescriptionData.isPrescription].text)}}</span>
      </div>
      <div class="step-time-bottom">
        <div class="step-time-bottom-child">
          <span class="time-bottom-title">{{$lang('预计全程时效')}}</span>
          <span class="time-bottom-day">{{prescriptionData.estimateDuration}}</span>
        </div>
        <div class="step-time-bottom-child">
          <span class="time-bottom-title">{{$lang('当前运输时长')}}</span>
          <span class="time-bottom-day">{{prescriptionData.currentDuration}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DetailStepBar',
  props: {
    prescriptionData: {
      type: Object,
      default: () => {}
    },
    trailList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      stepStyle: [
        {},
        {
          color: 'prescription',
          text: '整体时效内'
        },
        {
          color: 'prescriptionHigh',
          text: '整体时效外'
        }
      ]
    };
  },
  computed: {
    hasCollecting() {
      return this.trailList.find(o => o.status === '已代收')
    },
    stepList() {
      return [
        {
          title: '未揽收',
          icon: 'uncollected',
          img: 'uncollectedHigh',
          key: 1
        },
        {
          title: '已揽收',
          icon: 'received',
          img: 'receivedHigh',
          key: 2
        },
        {
          title: '中转中',
          icon: 'inTransit',
          img: 'inTransitHigh',
          key: 3
        },
        {
          title: '派送中',
          icon: 'inDelivery',
          img: 'inDeliveryHigh',
          key: 4
        },
        {
          title: '已代收',
          icon: 'daishou',
          img: 'daishouHigh',
          key: 6,
          hide: !this.hasCollecting
        },
        {
          title: '已签收',
          icon: 'signedReceived',
          img: 'signedReceivedHigh',
          key: 5
        }
      ].filter(o => !o.hide)
    }
  },
  methods: {
    getActive() {
      return this.stepList.findIndex(o => o.key === this.prescriptionData.transportationStatus)
    },
    getImg(item, index) {
      return index <= this.getActive() ? item.img : item.icon
    }
  }
};
</script>
<style lang="scss" scoped>
.step-bar {
  display: flex;
  width: calc(100% - 38px);
  height: 71px;
  white-space: nowrap;
  justify-content: space-between;
  background: rgba(242,243,245,0.33);
  border: 1px solid rgba(220,222,225,0.80);
  border-radius: 6px;
  padding: 7.5px 24px 12px 12px;
  margin-bottom: 20px;
  .step-left {
    width: 76%;
    border-right: 1px solid #dcdee1;
    padding-right: 49px;

    .step-reference {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 12px;
      color: #9499a3;
      line-height: 12px;
      img {
        height:15px;
        width: 14px;
      }
    }
  }

  .el-icon-warning {
    font-size: 22px;
    color: #E60012;
    width: 60px;
    span {
      font-size: 14px;
    }
  }
  .iconanniu-shijianxianzhipeizhi {
    font-size: 30px;
    line-height: 31px;
  }
  .step-line {
    ::v-deep .el-step__title {
      font-size: 12px !important;
      white-space: nowrap;
      line-height: 12px;
      padding-left: 9%;
    }
    ::v-deep .el-step__icon {
      border: none;
      width: 39%;
    }
    .step-img {
      height: 32px;
      width: 32px;
    }

    ::v-deep .last-img {
      .el-step__head {
        display: flex;
        justify-content: center;
      }
      .el-step__title {
        margin-top: 6px;
      }
    }
    ::v-deep .icon-content {
      display: flex;
      flex-direction: column;
      padding-top: 18px;
      align-items: center;
      span {
        padding-top: 6px;
      }
    }
    ::v-deep .is-finish {
      color: #E60012;
    }
    ::v-deep .el-step__line {
      border-color: #E60012 !important;
    }
    ::v-deep .is-process {
      color: #C0C4CC !important;
    }
  }
  .step-time {
    line-height: 11px;
    margin-left: 30px;
    width: 24%;

    .step-time-top {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
      color: #4c4d57;
      margin: 8px 0;
      img {
        margin-right: 6px;
        height: 20px;
        width: 20px;
      }
    }

    .step-time-bottom {
      display: flex;

      .step-time-bottom-child {
        display: flex;
        flex-direction: column;
        margin-right: 10px;

        .time-bottom-title {
          font-size: 12px;
          color: #9499a3;
          line-height: 17px;
        }

        .time-bottom-day {
          font-size: 14px;
          color: #4c4d57;
          line-height: 20px;
        }
      }
    }
  }
  .step-icon {
    width: 100px;
    text-align: center;
    line-height: 0;
  }
}
</style>
